import React from 'react';
import { ShopifyProvider } from '../../contexts/ShopifyContext';
import { Footer } from '../Footer';
import Navigation from './Navigation';

const Layout = ({ children, isHomepage = false }) => {
  return (
    <ShopifyProvider shopName="bluli" accessToken="cd15f6ba1ebdffa0f67395f80debc738">
      <div className="relative font-body text-blue-900 w-screen overflow-hidden">
        <Navigation isHomepage={isHomepage} />
        {children}
        <Footer />
      </div>
    </ShopifyProvider>
  );
};

export default Layout;
